import { Invoice } from "../../CRUDs/entities/Invoice";
import { Customer } from "../../CRUDs/entities/Customer";
import { PaymentForm } from "../../customer-cab/PaymentForm";
import { RefundForm } from "../RefundForm";
import { checkActionAttribute } from "./checkActionAttribute";
import { Visit } from "../../CRUDs/entities/Visit";

export const invoicesModalActionsListners = (target, actionsWindow, parents=null) => {

    checkActionAttribute([
        { attribute: 'data-customer-active',     className: 'refund-invoice' },
        { attribute: 'data-customer-active',     className: 'edit-invoice' },
        { attribute: 'data-customer-active',     className: 'create-visit' },
        { attribute: 'data-customer-active',     className: 'contact' },
        { attribute: 'data-customer-active',     className: 'to-pdf' },

        { attribute: 'data-need-payment',        className: 'pay-invoice' },
        { attribute: 'data-editable',            className: 'edit-invoice' },

        { attribute: 'data-change-allow',        className: 'void-invoice'},
        { attribute: 'data-change-allow',        className: 'uncollectable-invoice'},

    ], target, actionsWindow, parents);

    actionsWindow.find('.action').off();
    const invoiceId = target.parent().attr('data-id');
    const customerId = target.parent().attr('data-customer-id');

    const invoice = new Invoice(invoiceId);
    const customer = new Customer(customerId);
    const staticVisit = new Visit();

    //view invoice details
    actionsWindow.find('.action.view-invoice').on('click', (e) => {
        invoice.openModal('view');
    });

    // contact customer
    actionsWindow.find('.action.contact').on('click', (e) => {
        customer.openModal('contact', {id: customerId});
    });

    // edit invoice
    actionsWindow.find('.action.edit-invoice').on('click', (e) => {
        window.open(`${window.location.origin}/jobs-flow/invoice/${invoiceId}/edit`, '_blank');
    });

    // view logs
    actionsWindow.find('.action.view-logs').on('click', (e) => {
        invoice.openModal('logs');
    });

    // pay invoice
    actionsWindow.find('.action.pay-invoice').on('click', (e) => {
        invoice.openModal('payment');
        new PaymentForm(invoice);
    });

    // schedule a visit
    actionsWindow.find('.action.create-visit').on('click', (e) => {
        staticVisit.openModal('create', { job_request_id: target.parent().data('request-id') });
    });

    // to PDF
    actionsWindow.find('.action.to-pdf').attr('href', `/jobs-flow/invoice/${invoice.id}/pdf`);
}
